import { connect } from 'react-redux';
import FilterButton from '../components/toolbar/filter-button';

const mapStateToProps = () => ({
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FilterButton);
